import { render, staticRenderFns } from "./CourseCardSummary.vue?vue&type=template&id=79ec46e3&scoped=true"
import script from "./CourseCardSummary.vue?vue&type=script&lang=js"
export * from "./CourseCardSummary.vue?vue&type=script&lang=js"
import style0 from "./CourseCardSummary.vue?vue&type=style&index=0&id=79ec46e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec46e3",
  null
  
)

export default component.exports